import { render, staticRenderFns } from "./AmcPurchaseDialog.vue?vue&type=template&id=1f086258&scoped=true"
import script from "./AmcPurchaseDialog.vue?vue&type=script&lang=js"
export * from "./AmcPurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./AmcPurchaseDialog.vue?vue&type=style&index=0&id=1f086258&prod&scoped=true&lang=css"
import style1 from "./AmcPurchaseDialog.vue?vue&type=style&index=1&id=1f086258&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f086258",
  null
  
)

export default component.exports